export interface RankingItem {
  rank: number;
  name: string;
  avatar: string;
  score: number;
  category: string;
  streak: number;
  change: 'up' | 'down' | 'same';
}

export const dailyRankings: RankingItem[] = [
  { rank: 1, name: '李明', avatar: '', score: 9850, category: '知识竞赛', streak: 23, change: 'same' },
  { rank: 2, name: '王芳', avatar: '', score: 9200, category: '知识竞赛', streak: 18, change: 'up' },
  { rank: 3, name: '陈伟', avatar: '', score: 8950, category: '脑力竞技', streak: 15, change: 'up' },
  { rank: 4, name: '赵丽', avatar: '', score: 8720, category: '创意大赛', streak: 21, change: 'down' },
  { rank: 5, name: '刘洋', avatar: '', score: 8450, category: '游戏竞技', streak: 12, change: 'up' },
  { rank: 6, name: '孙悦', avatar: '', score: 8100, category: '运动挑战', streak: 30, change: 'same' },
  { rank: 7, name: '周杰', avatar: '', score: 7890, category: '音乐比赛', streak: 9, change: 'down' },
  { rank: 8, name: '吴敏', avatar: '', score: 7650, category: '知识竞赛', streak: 14, change: 'up' },
  { rank: 9, name: '郑浩', avatar: '', score: 7420, category: '脑力竞技', streak: 7, change: 'up' },
  { rank: 10, name: '黄蕾', avatar: '', score: 7280, category: '创意大赛', streak: 11, change: 'down' },
];

export const weeklyRankings: RankingItem[] = [
  { rank: 1, name: '张小花', avatar: '', score: 2450, category: '音乐比赛', streak: 7, change: 'up' },
  { rank: 2, name: '刘洋', avatar: '', score: 2380, category: '游戏竞技', streak: 7, change: 'same' },
  { rank: 3, name: '孙悦', avatar: '', score: 2310, category: '运动挑战', streak: 7, change: 'up' },
  { rank: 4, name: '李明', avatar: '', score: 2250, category: '知识竞赛', streak: 7, change: 'down' },
  { rank: 5, name: '赵丽', avatar: '', score: 2180, category: '创意大赛', streak: 6, change: 'up' },
  { rank: 6, name: '陈伟', avatar: '', score: 2100, category: '脑力竞技', streak: 5, change: 'down' },
  { rank: 7, name: '王芳', avatar: '', score: 2030, category: '知识竞赛', streak: 7, change: 'up' },
  { rank: 8, name: '周杰', avatar: '', score: 1950, category: '音乐比赛', streak: 4, change: 'up' },
  { rank: 9, name: '吴敏', avatar: '', score: 1880, category: '知识竞赛', streak: 5, change: 'down' },
  { rank: 10, name: '郑浩', avatar: '', score: 1800, category: '脑力竞技', streak: 3, change: 'up' },
];